(() => {
  angular.module('app').component('commonComponentsQueryFollowUpLogComponent', {
    templateUrl: require('./queryFollowUpLog.component.html'),
    controller: QueryFollowUpLogController,
    controllerAs: 'vm',
    bindings: {
      // ServiceRequestQueryDto.followUps, in the order the follow-ups happened.
      followUps: '<',
      // IANA time zone of the guarantee letter, as the rest of the query page renders its times.
      timeZoneId: '<',
      // Host page only: ServiceRequestQueryDto.canAddFollowUpRemark. Left unbound on the hospital
      // page, whose log is read-only.
      canAddRemark: '<?',
      // ServiceRequestQueryDto.id, needed only when a remark can be added.
      queryId: '<?',
      // Called once a remark has been saved, so the parent can reload the query.
      onChanged: '&?',
    },
  });

  QueryFollowUpLogController.$inject = [
    '$uibModal',
    'Hms.ServiceRequests.ServiceRequestQueryFollowUpType',
  ];

  function QueryFollowUpLogController($modal, enumServiceRequestQueryFollowUpType) {
    const vm = this;

    vm.enums = {};
    vm.enums.followUpType = enumServiceRequestQueryFollowUpType;

    vm.isSystem = isSystem;
    vm.getSummary = getSummary;
    vm.getInitials = getInitials;
    vm.getDateTimeString = getDateTimeString;
    vm.openRemarkModal = openRemarkModal;

    /* Functions */

    function isSystem(followUp) {
      return followUp.type === vm.enums.followUpType.System.id;
    }

    // "1 remark · 3 reminders" — how much chasing this query has had, at a glance.
    function getSummary() {
      const reminders = _.filter(vm.followUps, isSystem).length;
      const remarks = vm.followUps.length - reminders;

      const remarkText =
        remarks === 1
          ? App.localize('FollowUpLogOneRemark')
          : App.localize('FollowUpLogRemarks', remarks);
      const reminderText =
        reminders === 1
          ? App.localize('FollowUpLogOneReminder')
          : App.localize('FollowUpLogReminders', reminders);

      return `${remarkText} · ${reminderText}`;
    }

    // "Chen Hong" -> "CH", "Justin" -> "J": the badge that marks a person's remark in the log.
    function getInitials(followUp) {
      return (followUp.actorName || '')
        .trim()
        .split(/\s+/)
        .slice(0, 2)
        .map((word) => word.charAt(0).toUpperCase())
        .join('');
    }

    function getDateTimeString(date) {
      return App.getDateTimeString(date, vm.timeZoneId);
    }

    function openRemarkModal() {
      $modal
        .open({
          templateUrl: require('./addRemark/addRemarkModal.html'),
          controller: 'common.views.queryFollowUpLog.addRemarkModal as vm',
          backdrop: 'static',
          windowClass: 'follow-up-remark-modal',
          resolve: {
            queryId() {
              return vm.queryId;
            },
          },
        })
        .result.then(
          () => {
            if (vm.onChanged) vm.onChanged();
          },
          () => {
            // Dismissed without saving: nothing to reload.
          }
        );
    }
  }
})();
